import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserId } from "@sp-crm/core";

interface CalendarState {
    viewMode: "month" | "week" | "day";
    selectedUserId: UserId | undefined;
}
const initialState: CalendarState = {
    viewMode: "week",
    selectedUserId: undefined,
};

export const calendarSlice = createSlice({
    name: "calendar",
    initialState,
    reducers: {
        setViewMode: (state, action: PayloadAction<"month" | "week" | "day">) => {
            state.viewMode = action.payload;
        },
        setSelectedUserId: (state, action: PayloadAction<UserId | undefined>) => {
            state.selectedUserId = action.payload;
        },
    },
});
